import { BaseError } from './errors';

export class InvalidNumberError extends BaseError {
  constructor(propertyName: string) {
    super(`The value provided for "${propertyName}" is not a valid number`);
  }
}

export class InvalidTimeUnitError extends BaseError {
  constructor(unit: string) {
    super(`"${unit}" is not a valid time unit`);
  }
}

export class ParserError extends BaseError {
  constructor(error: string) {
    super(`An error occurred while parsing the data${error ? `: ${error}` : ''}`);
  }
}

export class SerializerError extends BaseError {
  constructor(error: string) {
    super(`An error occurred while serializing the data${error ? `: ${error}` : ''}`);
  }
}
